<template>
    <div class="w-full">
        <p v-if="hasErrors" class="text-red-800 dark:text-red-300 mt-4 text-sm">
            Looks like you have some validation errors, please go back and check
        </p>
        <ul class="mt-2 mb-4">
            <li
                v-for="(value, key, index) in errors"
                :key="`${ key }-${ index }`"
                class="text-red-800 dark:text-red-300 text-sm"
            >
                {{ value[0] || '' }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "Errors",
    props: {
        errors: {
            type: [Object, Array],
            required: true,
        },
    },
    computed: {
        hasErrors() {
            return !!Object.keys(this.errors).length;
        },
    },
};
</script>
